import script from "./EditBalise.vue?vue&type=script&setup=true&lang=js"
export * from "./EditBalise.vue?vue&type=script&setup=true&lang=js"

import "./EditBalise.vue?vue&type=style&index=0&id=28eab96c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28eab96c"]])

export default __exports__